import {generateFeatureToggleMap} from '../../modules/feature-toggle/featureToggleUtils';

function generateDefaultInitialFeatureToggleState() {
  return {
    pageFeatureToggleMap: null,
    appFeatureToggleMap: null,
  };
}

function featureToggleReducer(state = generateDefaultInitialFeatureToggleState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_APP_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        appFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_DESKTOP_HOME_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_MOBILE_HOME_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_MOBILE_CATEGORY_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_DESKTOP_CATEGORY_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_DESKTOP_SEARCH_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_MOBILE_SEARCH_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_DESKTOP_TAG_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_MOBILE_TAG_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_CAMPAIGN_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_DYNAMIC_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_DYNAMIC_VIEW_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_STATIC_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };

      break;
    }

    case 'GET_BRAND_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };
      break;
    }

    case 'GET_MOBILE_PRODUCT_DETAIL_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };
      break;
    }

    case 'GET_DESKTOP_PRODUCT_DETAIL_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };
      break;
    }

    case 'GET_AUTHORS_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action.payload.response.data.data,
        ),
      };
      break;
    }

    case 'GET_NOT_FOUND_PAGE_FEATURE_TOGGLES_FULFILLED': {
      newState = {
        ...state,
        pageFeatureToggleMap: generateFeatureToggleMap(
          action?.payload?.response?.data?.data,
        ),
      };
      break;
    }

    case 'LEAVE_HOME_PAGE_ROUTE':
    case 'LEAVE_COLLECTION_PAGE_ROUTE':
    case 'LEAVE_MERCHANT_PAGE_ROUTE':
    case 'LEAVE_DYNAMIC_VIEW_ROUTE':
    case 'LEAVE_TAG_PAGE_ROUTE':
    case 'LEAVE_BRAND_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_SEARCH_PAGE_ROUTE':
    case 'LEAVE_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_CAMPAIGN_PAGE_ROUTE':
    case 'LEAVE_DYNAMIC_PAGE_ROUTE':
    case 'LEAVE_STATIC_PAGE_ROUTE':
    case 'LEAVE_BRAND_PAGE_ROUTE':
    case 'LEAVE_PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU_ROUTE':
    case 'LEAVE_PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID_ROUTE':
    case 'LEAVE_PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU_ROUTE':
    case 'LEAVE_PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID_ROUTE':
    case 'LEAVE_AUTHORS_PAGE_ROUTE': {
      newState = {
        ...state,
        pageFeatureToggleMap: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}


export default featureToggleReducer;
export {generateDefaultInitialFeatureToggleState};
